import api from "./apiWithAccessToken";

/* 
   GROUP CRUD
 */

// LIST GROUPS
export const getGroups = () =>
  api.get("/groups/");

// GET SINGLE GROUP (Edit mode)
export const getGroupById = (groupId) =>
  api.get(`/groups/${groupId}`);

// CREATE GROUP
export const createGroup = (payload) =>
  api.post("/groups/", payload);

// UPDATE GROUP
export const updateGroup = (groupId, payload) =>
  api.put(`/groups/${groupId}`, payload);

// DELETE GROUP
export const deleteGroup = (groupId) =>
  api.delete(`/groups/${groupId}`);

/*  DATABASE + TABLE ACCESS */

// DB dropdown options
export const getGroupDBOptions = () =>
  api.get("/groups/db-options");

// Tables transfer list
export const getGroupTableOptions = (configId, groupId = null) => {
  const params = { config_id: configId };
  if (groupId !== null && groupId !== undefined) {
    params.group_id = groupId;
  }

  return api.get("/groups/table-options", { params });
};

export default api;
